<template>
    <div v-if="showConfirm" class="flex" :class="confirmText ? 'flex-col items-start gap-1' : ['items-center', labelOnly ? 'justify-start' : 'justify-center']">
        <!-- interactive off: its default wraps the button in an invisible 12px border (cancelled by a negative margin)
             that a scrolling ancestor still counts, so a button near a scroll edge raised a sideways scrollbar. The tooltip
             is plain text — nothing needs to hover into it. -->
        <!-- Two buttons, so the whole pill of each is the click target, not just its icon. This note sits outside the
             Popper: a comment inside it counts as a second child in development and Popper warns. -->
        <Popper hover arrow placement="top" :interactive="false" :content="'confirm'">
            <div class="bn-split" role="group" aria-label="Confirm or cancel">
                <button ref="confirmBtn" type="button" class="px-2" aria-label="Confirm" :disabled="disabled" @click="confirm()" @keydown.esc.prevent="showConfirm = false">
                    <CheckIcon class="text-green" />
                </button>
                <button type="button" aria-label="Cancel" @click="showConfirm = false" @keydown.esc.prevent="showConfirm = false">
                    <XIcon class="text-red" />
                </button>
            </div>
        </Popper>
        <!-- Optional consequence line while armed, under the ✓ | ✕, e.g. "Signs them out everywhere" -->
        <div v-if="confirmText" class="text-[11px] text-amber font-semibold whitespace-normal text-left">{{ confirmText }}</div>
    </div>
    <div v-else class="flex items-center" :class="labelOnly ? 'justify-start' : 'justify-center'">
        <Popper hover arrow placement="top" :interactive="false" :content="popperContent">
            <button type="button" :class="buttonClass" @click="showConfirm = true" :disabled="disabled">
                <component :is="isDelete ? 'TrashIcon' : iconComponent" class="h-4 w-4 flex-shrink-0" />
                <div v-if="buttonText" :class="[{'hidden sm:block': hideTextOnMobile},{'pr-1 py-0': buttonText}]">{{buttonText}}</div>
            </button>
        </Popper>
    </div>
</template>

<script>
import {CheckIcon,XIcon,TrashIcon} from "@heroicons/vue/solid"
import { nextTick, ref, watch } from 'vue'
export default {
    props:{
        buttonClass:{type:String,default:'bn-icon-only'},
        disabled:{type:Boolean,default:false},
        popperContent:{type:String,default:''},
        isDelete:{type:Boolean,default:false},
        iconComponent:{type:[Object, Function, String],default:'CheckIcon'},
        buttonText:{type:String,default:null},
        hideTextOnMobile:{type:Boolean,default:false},
        labelOnly:{type:Boolean,default:false},
        confirmText:{type:String,default:''},
    },
    components:{CheckIcon,XIcon,TrashIcon},
    emits:["confirmed"],
    setup (_,{emit}) {
        const showConfirm = ref(false)
        const confirmBtn = ref(null)

        // Armed: focus the ✓, so Enter confirms and Escape cancels.
        watch(showConfirm, (armed) => {
            if (armed) nextTick(() => confirmBtn.value?.focus())
        })

        const confirm = ()=>{
            emit("confirmed")
            showConfirm.value = false
        }

        return {
            showConfirm,
            confirmBtn,
            confirm,
        }
    }

}
</script>